import { z } from 'zod/v4';

import { avoidFavorTypeSchema } from './avoid-favor-type.schema';
import { extraInfoSchema } from './extra-info.schema';

export const routeModifierLinkSchema = z.object({
  afGroupID: z.number().nullable(),
  avoidFavorID: z.number(),
  avoidFavorType: avoidFavorTypeSchema,
  comment: z.string().nullable(),
  extraInfo: extraInfoSchema.nullable(),
  geometries: z.array(z.array(z.array(z.number()))).nullable(),
  gridID: z.number(),
  gridLevel: z.number(),
  linkID: z.number(),
  linkPoints: z.array(z.array(z.number())).nullable(),
  pliDs: z.array(z.number()),
});

export type RouteModifierLink = z.infer<typeof routeModifierLinkSchema>;
